/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AvailablePaymentTypes = {
    paymentTypes: Array<'online' | 'cash' | 'invoice'>;
    onlinePaymentMethods: Array<'card' | 'sepa' | 'paypal' | 'klarna' | 'bank_transfer' | 'apple_pay' | 'google_pay'>;
    onlineProviderType?: AvailablePaymentTypes.onlineProviderType | null;
    stripeConnectedAccountId?: string | null;
    stripePublishableKey?: string | null;
};
export namespace AvailablePaymentTypes {
    export enum onlineProviderType {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }
}

